import React, {useContext, useEffect, useMemo, useState} from "react";

import RightArrow from "../../../../../../../images/ArrowRight.svg";
import JunctionDetails from "../JunctionDetails";
import {TableType} from "../../../../../customer/companies/queries/types";
import {payloadTypes} from "../../../../../../../context/reducer";
import {AppContext} from "../../../../../../../context/context";
import {
  GetTickets,
  TicketNodeForDashBoard,
} from "../../../../../../../queries/queries";
import {
  AtsTicketsOrderField,
  GetTicketsVars,
  TicketNode,
  TicketsQueryType,
} from "../../../../../../../queries/types";
import {
  GetTicketsData,
  GetTicketsResult,
  TicketEdge,
} from "../../../queries/types";
import {useLazyQuery} from "@apollo/client";
import {
  convertToTimeZone,
  getAging,
  getModifiedScrollHeight,
  ticketPriorityClassName,
  ticketStatusClassName,
  toStandardDate,
} from "../../../../../../../utils/UtilFunctions";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  TicketStatus,
} from "../../../../../../../utils/constants";

import {MapsContext} from "../../../context/context";
import useUrlParams from "../../../../../../../customHooks/useUrlParams";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../../utils/commonQueryTypes";
import useLoggedInUserDetails from "../../../../../../../customHooks/useLoggedInUserDetails";
import {TimeZone} from "../../../../../../../utils/Enum.types";
import {mapsPayloadType} from "../../../context/reducer";
import useServerDateandTime from "../../../../../../../customHooks/useServerDateandTime";
import {AssetDetailsPageFor} from "./AssetDetails";
import LoadingModal from "../../../../../../pages/LoadingModal";
const ticketDetails = [
  {
    ticket_no: "TICKET001",
    raised_date: "01-01-2025",
    time: "3:45pm",
    reason: "Repair",
    ageing: "1day : 8hr : 45min",
    maintained_by: "vendor",
    status: "open",
    id: 1,
  },
  {
    ticket_no: "TICKET001",
    raised_date: "01-01-2025",
    time: "3:45pm",
    reason: "Repair",
    ageing: "1day : 8hr : 45min",
    maintained_by: "vendor",
    status: "open",
    id: 2,
  },
];
interface Props {
  pageFor: AssetDetailsPageFor;
  assetType: TableType;
}
const TicketDetails = ({pageFor, assetType}: Props) => {
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [tickets, setTickets] = useState<TicketEdge[]>([]);

  const {state, dispatch} = useContext(MapsContext);
  const {state: globalState, dispatch: globalDispatch} = useContext(AppContext);
  const {customer_id} = useUrlParams();
  const [searchData, setSearchData] = useState("");
  const {user_details} = useLoggedInUserDetails();
  const {
    serverDate,
    data: serverData,
    loading: serverLoading,
  } = useServerDateandTime();

  const [GetTicket, {data, loading, fetchMore}] = useLazyQuery<
    GetTicketsResult,
    GetTicketsVars
  >(GetTickets);

  const [GetSingleTicket, {data: singleTicketData}] = useLazyQuery<
    {node: TicketNode},
    nodeVar
  >(TicketNodeForDashBoard);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetTickets.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = tickets.find(
            (ticket) => ticket.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setTickets(updatedNewData);
      } else {
        setTickets(newData);
      }

      setEndCursor(data.GetTickets.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [loading, data]);

  const rows = useMemo(() => {
    return data
      ? data.GetTickets.edges.map(({node}, index) => ({
          id: index + 1,
          logNo: node.ticketNo,
          asset: node.item.desc,
          asset_slno: node.itemDetails.prodSerialNo,
          ticket_date: toStandardDate(node.ticketDate),
          subsidiary: node.subsidiaryDetails.name,
          ticket_reason: EMPTY_STRING,
          status: node.status,
          maintained_by: "",
          attachments: "",
          priority: node.priority,
          ticket_status: node.status,
          ticket_id: node.id,
          asset_id: node.itemDetails.id,
        }))
      : [];
  }, [data]);

  useEffect(
    () => {
      const scrollTable = document.getElementsByClassName(
        "MuiDataGrid-virtualScroller"
      )[0] as Element;
      const handleScroll = (e: Event) => {
        const target = e.target as HTMLDivElement;
        const scrollTop = target.scrollTop;
        const scrollHeight = target.scrollHeight;
        const clientHeight = target.clientHeight;

        if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
          if (hasNextPage && !loading) {
            fetchMore({
              variables: {
                first: FETCH_MORE_DATA,
                after: endCursor,
              },
              updateQuery: (prevResult, {fetchMoreResult}) => {
                if (!fetchMoreResult) return prevResult;

                const newEdges = fetchMoreResult.GetTickets.edges;
                const pageInfo = fetchMoreResult.GetTickets.pageInfo;

                setEndCursor(pageInfo.endCursor);
                setHasNextPage(pageInfo.hasNextPage);

                const duplicateCheck = prevResult.GetTickets
                  ? prevResult.GetTickets.edges.filter(
                      ({node: {id}}) =>
                        newEdges.findIndex(
                          ({node: {id: newId}}) => newId === id
                        ) !== -1
                    )
                  : [];

                if (duplicateCheck.length > 0) return prevResult;

                return {
                  GetTickets: {
                    edges: [...tickets, ...newEdges],
                    pageInfo,
                    totalCount: data ? data.GetTickets.totalCount! : 0,
                  },
                };
              },
            });
          }
        }
      };
      if (scrollTable && rows.length)
        scrollTable.addEventListener("scroll", handleScroll);

      return () => {
        // eslint-disable-next-line
        if (scrollTable)
          scrollTable.removeEventListener("scroll", handleScroll);
      };
    },
    // eslint-disable-next-line
    [rows, endCursor]
  );

  useEffect(() => {
    if (customer_id && pageFor === AssetDetailsPageFor.MAPS) {
      GetTicket({
        variables: {
          after: null,
          first: ROWS_PER_PAGE,
          name: searchData,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsTicketsOrderField.TICKET_NO,
          },

          companyID: 0,
          customerID: customer_id,
          subsidiaryID: 0,
          junctionID:
            assetType === TableType.JUNCTION
              ? state.assetTypeId || globalState.junctionID
              : 0,
          reason: EMPTY_STRING,
          input: {
            itemID: 0,
            ldgrID: 0,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckSubCategoryID: 0,
            stckUomID: 0,
            query_type: TicketsQueryType.ALL,
            itemDetailsID:
              assetType === TableType.ASSET ? state.assetTypeId : 0,
            status: [
              TicketStatus.ASSIGNED,
              TicketStatus.OPEN,
              TicketStatus.RESOLVED,
              TicketStatus.RE_OPENED,
            ],
            empID: user_details.id!,
            priority: [],
          },
          siteID: 0,
        },
      });
    }
  }, [
    GetTicket,
    searchData,
    state.assetTypeId,
    user_details.id,
    customer_id,
    assetType,
    globalState.itemDetailsId,
    pageFor,
    globalState.junctionID,
  ]);

  useEffect(() => {
    if (customer_id) {
      GetSingleTicket({
        variables: {
          id: state.ticketId
            ? state.ticketId
            : globalState.ticketId
            ? globalState.ticketId
            : 0,
        },
      });
    }
  }, [
    GetSingleTicket,
    state.ticketId,
    globalState.ticketId,
    customer_id,
    pageFor,
  ]);

  // const getAging = (date: string) => {
  //   if (serverData && !serverLoading) {
  //     const presentDate = new Date(serverDate);
  //     const ticketDate = new Date(date);

  //     const diffMs = Math.abs(ticketDate.getTime() - presentDate.getTime()); // Absolute difference in ms

  //     const diffSec = Math.floor(diffMs / 1000); // Total seconds
  //     const diffMin = Math.floor(diffSec / 60); // Total minutes
  //     const diffHours = Math.floor(diffMin / 60); // Total hours
  //     const diffDays = Math.floor(diffHours / 24); // Total days

  //     const remainingHours = diffHours % 24; // Hours excluding full days
  //     const remainingMinutes = diffMin % 60; // Minutes excluding full hours
  //     const remainingSeconds = diffSec % 60; // Seconds excluding full minutes

  //     let result = "";
  //     if (diffDays) result += `${diffDays} days `;
  //     if (remainingHours) result += `${remainingHours} hrs `;
  //     if (remainingMinutes) result += `${remainingMinutes} mins `;
  //     if (remainingSeconds) result += `${remainingSeconds} secs`;

  //     return result.trim(); // Remove extra spaces
  //   }
  //   return "";
  // };

  return (
    <div className="jucn-ticket-details">
      <JunctionDetails assetType={assetType} viewIcon={true} />
      <div className="jucn-ticket-details__header">
        <b>Ticket Raised</b>
      </div>
      <ul className="jucn-ticket-details__ul">
        {pageFor === AssetDetailsPageFor.MAPS ? (
          <>
            {data
              ? data.GetTickets.edges.map(({node}, index) => {
                  return (
                    <li
                      onClick={() => {
                        dispatch({
                          type: mapsPayloadType.TICKET,
                          payload: {
                            ticketId: node.id,
                          },
                        });
                        globalDispatch({
                          type: payloadTypes.SET_COMPANY_ID,
                          payload: {
                            companyId: node.company.id,
                          },
                        });
                      }}
                    >
                      <div>
                        <div className="jucn-ticket-details__ul--grid">
                          <label>Ticket No.</label>
                          <span>:</span>
                          <b className="font-red">{node.ticketNo}</b>
                        </div>
                        <div className="jucn-ticket-details__ul--grid">
                          <label>Ticket Status</label>
                          <span>:</span>
                          <b className={ticketStatusClassName(node.status)}>
                            {node.status}
                          </b>
                        </div>
                        <div className="jucn-ticket-details__ul--grid">
                          <label>Ticket Raised Date</label>
                          <span>:</span>
                          <b>
                            {
                              convertToTimeZone(
                                TimeZone.Asia_Kolkata,
                                node.ticketDate
                              ).date
                            }{" "}
                            <span className="font-grey">
                              {
                                convertToTimeZone(
                                  TimeZone.Asia_Kolkata,
                                  node.ticketDate
                                ).time
                              }
                            </span>
                          </b>
                        </div>
                        <div className="jucn-ticket-details__ul--grid">
                          <label>Ticket Raised By</label>
                          <span>:</span>
                          <div className="bg-grey">
                            <b>{node.loggedUser.name}</b>
                            {/* <span className="font-blue">
                      {singleTicketData.node.loggedUser.name}
                    </span>
                    <span className="font-grey">
                      {singleTicketData.node.loggedUser.name}
                    </span> */}
                          </div>
                        </div>
                        <div className="jucn-ticket-details__ul--grid">
                          <label>Ticket Reason</label>
                          <span>:</span>
                          <b>{node.reason}</b>
                        </div>

                        <div className="jucn-ticket-details__ul--grid">
                          <label>Ageing</label>
                          <span>:</span>
                          <b>{getAging(node.ticketDate, serverDate)} </b>
                        </div>
                        <div className="jucn-ticket-details__ul--grid">
                          <label>Maintained By</label>
                          <span>:</span>
                          <b>{node.vendorDetails.desc}</b>
                        </div>
                        <div className="jucn-ticket-details__ul--grid">
                          <label>Ticket Priority</label>
                          <span>:</span>
                          <b className={ticketPriorityClassName(node.priority)}>
                            {node.priority}
                          </b>
                        </div>
                      </div>
                      <img src={RightArrow} alt="" />
                    </li>
                  );
                })
              : null}
          </>
        ) : (
          singleTicketData && (
            <li
              onClick={() => {
                dispatch({
                  type: mapsPayloadType.TICKET,
                  payload: {
                    ticketId: singleTicketData.node.id,
                  },
                });
              }}
            >
              <div>
                <div className="jucn-ticket-details__ul--grid">
                  <label>Ticket No.</label>
                  <span>:</span>
                  <b className="font-red">{singleTicketData.node.ticketNo}</b>
                </div>
                <div className="jucn-ticket-details__ul--grid">
                  <label>Ticket Status</label>
                  <span>:</span>
                  <b
                    className={`jucn-ticket-details__ul--status ${ticketStatusClassName(
                      singleTicketData.node.status
                    )}`}
                  >
                    {singleTicketData.node.status}
                  </b>
                </div>
                <div className="jucn-ticket-details__ul--grid">
                  <label>Ticket Raised Date</label>
                  <span>:</span>
                  <b>
                    {
                      convertToTimeZone(
                        TimeZone.Asia_Kolkata,
                        singleTicketData.node.ticketDate
                      ).date
                    }{" "}
                    <span className="font-grey">
                      {
                        convertToTimeZone(
                          TimeZone.Asia_Kolkata,
                          singleTicketData.node.ticketDate
                        ).time
                      }
                    </span>
                  </b>
                </div>
                <div className="jucn-ticket-details__ul--grid">
                  <label>Ticket Raised By</label>
                  <span>:</span>
                  <div className="bg-grey">
                    <b>{singleTicketData.node.loggedUser.name}</b>
                    {/* <span className="font-blue">
                      {singleTicketData.node.loggedUser.name}
                    </span>
                    <span className="font-grey">
                      {singleTicketData.node.loggedUser.name}
                    </span> */}
                  </div>
                </div>
                <div className="jucn-ticket-details__ul--grid">
                  <label>Ticket Reason</label>
                  <span>:</span>
                  <b>{singleTicketData.node.reason}</b>
                </div>
                <div className="jucn-ticket-details__ul--grid">
                  <label>Ageing</label>
                  <span>:</span>
                  <b>
                    {getAging(singleTicketData.node.ticketDate, serverDate)}{" "}
                  </b>
                </div>

                <div className="jucn-ticket-details__ul--grid">
                  <label>Maintained By</label>
                  <span>:</span>
                  <b>{singleTicketData.node.vendorDetails.desc}</b>
                </div>

                <div className="jucn-ticket-details__ul--grid">
                  <label>Ticket Priority</label>
                  <span>:</span>
                  <b
                    className={ticketPriorityClassName(
                      singleTicketData.node.priority
                    )}
                  >
                    {singleTicketData.node.priority}
                  </b>
                </div>
                <div className="jucn-ticket-details__ul--grid">
                  <label>Complaint Description</label>
                  <span>:</span>
                  <b>{singleTicketData.node.remarks}</b>
                </div>
              </div>
            </li>
          )
        )}
      </ul>
      <LoadingModal flag={loading} />
    </div>
  );
};

export default TicketDetails;
